import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { TRANSFORMERS, $convertToMarkdownString } from '@lexical/markdown'
import { $generateHtmlFromNodes } from '@lexical/html'

const OnCustomChangePlugin = ({ onChange, isMarkdown }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const removeUpdateListener = editor.registerUpdateListener(
      ({ editorState }) => {
        editorState.read(() => {
          const output = isMarkdown
            ? $convertToMarkdownString(TRANSFORMERS)
            : $generateHtmlFromNodes(editor)
          onChange(output)
        })
      }
    )
    return () => {
      removeUpdateListener()
    }
  }, [editor, onChange, isMarkdown])

  return null
}

OnCustomChangePlugin.propTypes = {
  onChange: PropTypes.func.isRequired,
  isMarkdown: PropTypes.bool
}

OnCustomChangePlugin.defaultProps = {
  isMarkdown: true
}

export default OnCustomChangePlugin
